import { Page } from "../../../activities/AppPage";
import useTrainingCenterState from "../../../hooks/useTrainingCenterState";
import { isLoading, Loading } from "../../../Loading";
import { TrainingCenterBundleDueDateId } from "../../../messages";
import { AppState } from "../../../system/AppState";

export default function useOnboardingOrientation(params: {
  appState: AppState;
  orientationBundleDueDateId: TrainingCenterBundleDueDateId | Loading;
  onRequestNavigate: (page: Page) => void;
}) {
  const trainingCenterState = useTrainingCenterState(params.appState);

  const bundle = (() => {
    if (isLoading(trainingCenterState) || isLoading(params.orientationBundleDueDateId)) {
      return undefined;
    }

    return trainingCenterState.bundles.bundles.find(
      (x) => x.bundleDueDateId === params.orientationBundleDueDateId
    );
  })();

  const navigateToBundle = () => {
    if (bundle === undefined) {
      return;
    }

    return params.onRequestNavigate({
      type: "TrainingCenterBundle",
      bundleDueDateId: bundle.bundleDueDateId,
    });
  };

  const isCompleted = bundle === undefined;

  return {
    navigateToBundle,
    bundle,
    isCompleted,
  };
}
